export enum Gender {
  None,
  Female,
  Male,
}
export enum RowState {
  NoChange = 0,
  New = 1,
  Modify = 2,
  Delete = 3,
  SoftDelete = 5,
  Detached = 6,
}

export enum PersonalityKind {
  /// <summary>
  /// شخصیت حقیقی
  /// </summary>
  Real = 1,
  /// <summary>
  /// شخصیت حقوقی
  /// </summary>
  Legal = 2,
}
export enum InformationKind {
  /// <summary>
  /// سرنخ
  /// </summary>
  Lead = 1,
  /// <summary>
  /// فرصت
  /// </summary>
  Opportunity = 2,
  /// <summary>
  /// طرف حساب
  /// </summary>
  AccountSide = 3,
}
export enum ProductKind {
  /// <summary>
  /// نرم افزار
  /// </summary>
  SoftWare = 1,
  /// <summary>
  /// سخت افزار
  /// </summary>
  Hardware = 2,
}
export enum SoftWareKind {
  /// <summary>
  /// سپیدز
  /// </summary>
  Sepidz = 1,
  /// <summary>
  /// سیما
  /// </summary>
  Sima = 2,
}
export enum GoodsKind {
  /// <summary>
  /// کالا
  /// </summary>
  Goods = 1,
  /// <summary>
  /// خدمت
  /// </summary>
  Service = 2,
  /// <summary>
  /// امکانات
  /// </summary>
  Facilities = 3,
  /// <summary>
  /// سیستم
  /// </summary>
  System = 4,
  /// <summary>
  /// سیستم
  /// </summary>
  Package = 5,
}
export enum GoodsUnit {
  /// <summary>
  /// نسخه
  /// </summary>
  Version = 1,
  /// <summary>
  /// عددد
  /// </summary>
  NUmber = 2,
  /// <summary>
  /// ساعت
  /// </summary>
  Hour = 3,
  /// <summary>
  /// جلسه
  /// </summary>
  Meet = 4,
  /// <summary>
  /// دوره
  /// </summary>
  Period = 5,
  /// <summary>
  /// بسته
  /// </summary>
  Package = 6,
}

export enum OrderStateKind {
  /// <summary>
  /// ثبت شده
  /// </summary>
  Registered = 1,
  /// <summary>
  /// تسویه شده
  /// </summary>
  Cleared = 2,
  /// <summary>
  /// ابطال شده
  /// </summary>
  Cancelled = 3,
  /// <summary>
  /// تکمیل شده
  /// </summary>
  Complited = 4,
  /// <summary>
  /// نیاز به بررسی
  /// </summary>
  Pending = 5,
}
export enum ECalendarValue {
  Moment = 1,
  MomentArr,
  String,
  StringArr,
}
export enum CreditEffect {
  /// <summary>
  /// افزاینده
  /// </summary>
  Debit = 1,
  /// <summary>
  /// کاهنده
  /// </summary>
  Credit = 2,
}
export enum CreditState {
  /// <summary>
  /// ثبت شده
  /// </summary>
  Registered = 1,
  /// <summary>
  /// تائید شده
  /// </summary>
  validity = 2,
  /// <summary>
  /// رد شده
  /// </summary>
  failed = 3,
}
export enum PaymentKind {
  /// <summary>
  /// آنلاین
  /// </summary>
  OnLine = 1,
  /// <summary>
  /// فیش واریز
  /// </summary>
  Receipt = 2,
  /// <summary>
  /// آزد
  /// </summary>
  Free = 3,
  /// <summary>
  /// سفارش
  /// </summary>
  Order = 4,
  /// <summary>
  /// فاکتور
  /// </summary>
  Invoice = 5,
  /// <summary>
  /// برگشت از فاکتور
  /// </summary>
  InvoiceReturn = 6,
}
export enum LockKind {
  /// <summary>
  /// مشتری
  /// </summary>
  Customer = 1,
  /// <summary>
  /// نمایندگی
  /// </summary>
  Agent = 2,
  /// <summary>
  /// هدیه
  /// </summary>
  Gift = 3,
  /// <summary>
  /// آموزش
  /// </summary>
  Education = 4,
  /// <summary>
  /// نمایندگی آموزش
  /// </summary>
  EducationAgent = 5,
}
export enum LockSateKind {
  /// <summary>
  /// دست نماینده
  /// </summary>
  Agent = 1,
  /// <summary>
  /// دست مشتری
  /// </summary>
  Customer = 2,
}
export enum TelephoneKind {
  /// <summary>
  /// دفتر
  /// </summary>
  Office = 1,
  /// <summary>
  /// موبایل
  /// </summary>
  Mobile = 2,
  /// <summary>
  /// کارخانه
  /// </summary>
  Factory = 3,
  /// <summary>
  /// انبار
  /// </summary>
  Warehouse = 4,
  /// <summary>
  /// منزل
  /// </summary>
  Home = 5,
  /// <summary>
  /// سایر
  /// </summary>
  Other = 6,
}
export enum CalculationKind {
  /// <summary>
  /// درصدی
  /// </summary>
  Percentage = 1,
  /// <summary>
  /// مبلغی
  /// </summary>
  Amount = 2,
}
export enum OrderKind {
  /// <summary>
  /// شفارش جدید
  /// </summary>
  NewOrder = 1,
  /// <summary>
  /// تکمیل سفارش
  /// </summary>
  CompleteOrder = 2,
}

export enum ControlTypes {
  Radio,
  Check,
  DropDown,
  Grid,
  NumericTextBox,
  TimeTextBox,
  CheckAndNumericTextBox,
  TextBox,
  lookup,
  Button,
  Break,
}
export enum ReportKind {
  print,
  preview,
  editReport,
  newReport,
  saveReport,
}
export enum NumberType {
  Mobile = 1,
  Phone = 2,
}
export enum WebKind {
  Delino = 1,
  Snap = 2,
  Vendo = 3,
}
export enum SystemKind {
  /// <summary>
  /// حسابداری
  /// </summary>
  ACC = 1,
  /// <summary>
  /// خرید و انبار
  /// </summary>
  INV = 2,
  /// <summary>
  /// فروش و مشتری
  /// </summary>
  SELL = 3,
  /// <summary>
  /// دریافت و پردات
  /// </summary>
  TRS = 4,
  /// <summary>
  /// حقوق دستمزد
  /// </summary>
  HRM = 5,
  /// <summary>
  /// امور مراسم
  /// </summary>
  HALL = 6,
  /// <summary>
  /// فروش رستورانی
  /// </summary>
  SALE = 7,
}
export enum AccStatusKind {
  /// <summary>
  /// یاداشت
  /// </summary>
  Write = 1,
  /// <summary>
  /// موقت
  /// </summary>
  Inspection = 2,
  /// <summary>
  /// بررسی شده
  /// </summary>
  Confirm = 3,
  /// <summary>
  /// قطعی شده
  /// </summary>
  Approve = 4,
}
export enum AccountBalanceKind {
  /// <summary>
  /// خنثی
  /// </summary>
  neutral = 1,
  /// <summary>
  /// بدهکار طی دوره
  /// </summary>
  debtorDuringThePeriod = 2,
  /// <summary>
  /// بستانکار طی دوره
  /// </summary>
  creditorDuringThePeriod = 3,
  /// <summary>
  /// بدهکار پایان دوره
  /// </summary>
  debtorAtTheEndOfTheCourse = 4,
  /// <summary>
  /// بستانکار پایان دوره
  /// </summary>
  creditorAtTheEndOfTheCourse = 5,
}

export enum InvStatusKind {
  /// <summary>
  /// ثبت اولیه
  /// </summary>
  Registered = 1,
  /// <summary>
  /// تایید تعدادی
  /// </summary>
  Confirmed = 2,
  /// <summary>
  /// ثبت حسابداری
  /// </summary>
  AccountRegistered = 3,
  /// <summary>
  /// ابطال
  /// </summary>
  Cancelled = 4,
  /// <summary>
  /// ریالی شده
  /// </summary>
  Calculated = 5,
  /// <summary>
  /// اختتام
  /// </summary>
  Closing = 6,
}
export enum SellStatusKind {
  /// <summary>
  /// ثبت یاداشت
  /// </summary>
  NoteRegistered = 0,
  /// <summary>
  /// ثبت اولیه
  /// </summary>
  Registered = 1,
  /// <summary>
  /// تایید
  /// </summary>
  Confirmed = 2,
  /// <summary>
  /// ثبت حسابداری
  /// </summary>
  AccountRegistered = 3,
  /// <summary>
  /// ابطال
  /// </summary>
  Cancelled = 4,
  /// <summary>
  /// اختتام
  /// </summary>
  Closing = 5,
}
export enum IncrementalKind {
  /// <summary>
  /// افزاینده
  /// </summary>
  Increment = 1,
  /// <summary>
  /// کاهنده
  /// </summary>
  Decrement = 2,
  /// <summary>
  /// خنثی
  /// </summary>
  Neutral = 3,
  /// <summary>
  /// ماهیت بدهکار
  /// </summary>
  Debtor = 4,
  /// <summary>
  /// ماهیت بستانکار
  /// </summary>
  Creditor = 5,
}

export enum ItemAdjustmentKind {
  /// <summary>
  /// اضافات
  /// </summary>
  Surplusage = 1,

  /// <summary>
  /// کسورات
  /// </summary>
  Deduction = 2,
}

export enum InvGoodsKind {
  /// <summary>
  /// مواد اولیه
  /// </summary>
  RawMaterials = 1,
  /// <summary>
  /// دارایی
  /// </summary>
  Assets = 2,
  /// <summary>
  /// محصول
  /// </summary>
  Product = 3,
  /// <summary>
  /// نیمه ساخته
  /// </summary>
  HalfMade = 4,
  /// <summary>
  /// ضایعات
  /// </summary>
  Wastes = 5,
  /// <summary>
  /// پخش
  /// </summary>
  Distribution = 6,
  /// <summary>
  /// غیر مصرفی
  /// </summary>
  NonConsumable = 7,
  /// <summary>
  /// نامنقول
  /// </summary>
  GoodsImmovable = 8,
  /// <summary>
  /// نامشهود
  /// </summary>
  Invisible = 9,
  /// <summary>
  /// سایر
  /// </summary>
  Others = 10,
}

export enum RowAccessKind {
  /// <summary>
  /// حساب معين
  /// </summary>
  SubLedger = 1,

  /// <summary>
  /// حساب تفصيل
  /// </summary>
  DetailLedger = 2,

  /// <summary>
  /// انبار
  /// </summary>
  Warehouse = 3,

  /// <summary>
  /// كالا
  /// </summary>
  Goods = 4,
  /// <summary>
  /// شعبه
  /// </summary>
  Branch = 5,
  /// <summary>
  /// مركز فروش
  /// </summary>
  SellKind = 6,
}
